var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-form-container" },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.formDataLoading } },
        [
          _c(
            "a-form",
            {
              attrs: { form: _vm.form, layout: "vertical" },
              on: { submit: _vm.submit }
            },
            [
              _c(
                "a-form-item",
                [
                  _vm.showSaveButton
                    ? _c(
                        "a-button",
                        {
                          attrs: {
                            type: "primary",
                            "html-type": "submit",
                            loading: _vm.submitLoading
                          }
                        },
                        [_vm._v("\n          Mentés\n        ")]
                      )
                    : _vm._e(),
                  _vm.hasChanged()
                    ? _c(
                        "a-button",
                        {
                          attrs: { type: "secondary", "html-type": "button" },
                          on: { click: _vm.resetForm }
                        },
                        [
                          _c("a-icon", {
                            attrs: { type: "undo", theme: "outlined" }
                          }),
                          _vm._v("\n\n          Piszkozat törlése\n        ")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.currentTab
                    ? _c("span", { staticClass: "last-modification" }, [
                        _vm._v("\n          Utolsó mentés: "),
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm
                                .moment(_vm.currentTab.modificationTime)
                                .format(_vm.timeStampFormat)
                                .toString()
                            )
                          )
                        ]),
                        _vm._v("  "),
                        _vm.currentTab.user
                          ? _c("span", [
                              _vm._v(
                                "(" + _vm._s(_vm.currentTab.user.userName) + ")"
                              )
                            ])
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm.submitResult.show
                    ? _c("a-alert", {
                        style: {
                          marginTop: "10px"
                        },
                        attrs: {
                          message: _vm.submitResult.message,
                          type: _vm.submitResult.type,
                          showIcon: "",
                          closable: "",
                          afterClose: function() {
                            return (_vm.submitResult.show = false)
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c("a-divider", { attrs: { orientation: "left" } }, [
                _vm._v("\n        AZ ESEMÉNY BEMUTATÁSA\n      ")
              ]),
              _c("h3", [
                _vm._v(
                  "\n        A esemény általános bemutatása, leírása, kiemelendő értékei, története, fontosabb célcsoportjai\n        stb.\n      "
                )
              ]),
              _c(
                "a-form-item",
                {
                  attrs: {
                    selfUpdate: true,
                    label: "Rövid leírás (200-255 karakter)"
                  }
                },
                [
                  _c("Wysiwyg", {
                    directives: [
                      {
                        name: "decorator",
                        rawName: "v-decorator",
                        value: [
                          "shortDescription",
                          {
                            rules: [
                              {
                                transform: function(value) {
                                  return _vm.stripTags(value)
                                },
                                required: true,
                                preserve: true,
                                min: _vm.characterCounts.shortDescription.min,
                                max: _vm.characterCounts.shortDescription.max,
                                message:
                                  "Kérjük töltse ki! A leírás hosszának " +
                                  _vm.characterCounts.shortDescription.min +
                                  " és " +
                                  _vm.characterCounts.shortDescription.max +
                                  " között kell lennie."
                              }
                            ],
                            validateTrigger: ["blur", "keyup"]
                          }
                        ],
                        expression:
                          "[\n                          'shortDescription',\n                          {\n                              rules: [\n                                  {\n                                    transform: (value) => {\n                                      return stripTags(value);\n                                    },\n                                    required: true,\n                                    preserve: true,\n                                    min: characterCounts.shortDescription.min,\n                                    max: characterCounts.shortDescription.max,\n                                    message: 'Kérjük töltse ki! A leírás hosszának ' + characterCounts.shortDescription.min\n                                    + ' és ' + characterCounts.shortDescription.max + ' között kell lennie.',\n                                  }\n                              ],\n                              validateTrigger: ['blur', 'keyup']\n                          }\n                      ]"
                      }
                    ],
                    attrs: {
                      maxLength: 25000,
                      height: 100,
                      autoSize: {
                        minRows: 3
                      }
                    },
                    on: {
                      keyup: _vm.characterCount,
                      change: _vm.characterCount
                    }
                  }),
                  _c("div", { staticClass: "character-count" }, [
                    _c(
                      "strong",
                      {
                        class: {
                          invalid:
                            _vm.characterCounts.shortDescription.valid ===
                            false,
                          valid:
                            _vm.characterCounts.shortDescription.valid === true
                        }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.characterCounts.shortDescription.current
                            ) +
                            "\n          "
                        )
                      ]
                    ),
                    _vm._v(
                      "\n\n          / " +
                        _vm._s(_vm.characterCounts.shortDescription.min) +
                        " - " +
                        _vm._s(_vm.characterCounts.shortDescription.max) +
                        "\n        "
                    )
                  ])
                ],
                1
              ),
              _vm._l(_vm.translatedFormFields["shortDescription"], function(
                value,
                locale
              ) {
                return _c(
                  "div",
                  { key: "shortDescription-" + locale },
                  [
                    value !== null
                      ? _c("a-row", [
                          _c(
                            "div",
                            [
                              _c(
                                "a-form-item",
                                [
                                  _c(
                                    "div",
                                    { attrs: { slot: "label" }, slot: "label" },
                                    [
                                      _vm._v(
                                        "\n                Nyelv\n              "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "a-select",
                                    {
                                      directives: [
                                        {
                                          name: "decorator",
                                          rawName: "v-decorator",
                                          value: [
                                            _vm.getTranslatedLocaleName(
                                              "shortDescription",
                                              locale
                                            ),
                                            {
                                              initialValue: locale,
                                              rules: [
                                                {
                                                  required: false
                                                }
                                              ]
                                            }
                                          ],
                                          expression:
                                            "[\n                              getTranslatedLocaleName('shortDescription', locale),\n                              {\n                                  initialValue: locale,\n                                  rules: [{\n                                      required: false,\n                                  }]\n                              }\n                          ]"
                                        }
                                      ],
                                      ref: _vm.getTranslatedLocaleName(
                                        "shortDescription",
                                        locale
                                      ),
                                      refInFor: true,
                                      staticStyle: { width: "90%" },
                                      attrs: {
                                        getPopupContainer: _vm.getParentTriggerNode(),
                                        disabled: _vm.isTranslationEditDisabled,
                                        filterOption: _vm.filterSelectNames
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.updateTranslatedFormField(
                                            "shortDescription"
                                          )
                                        }
                                      }
                                    },
                                    _vm._l(_vm.languages, function(language) {
                                      return _c(
                                        "a-select-option",
                                        {
                                          key: language.name,
                                          attrs: {
                                            value: language.locale,
                                            disabled: !_vm.isLanguageAvailable(
                                              "shortDescription",
                                              language.locale
                                            )
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                language.name.toLowerCase()
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    }),
                                    1
                                  ),
                                  _vm.isAdmin
                                    ? _c(
                                        "a-tooltip",
                                        { attrs: { title: "Mező törlése" } },
                                        [
                                          _c("a-icon", {
                                            staticClass:
                                              "dynamic-delete-button",
                                            attrs: {
                                              type: "delete",
                                              theme: "filled"
                                            },
                                            on: {
                                              click: function() {
                                                return _vm.deleteTranslatedFormField(
                                                  "shortDescription",
                                                  locale
                                                )
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            [
                              _c(
                                "a-form-item",
                                { attrs: { selfUpdate: true } },
                                [
                                  _c(
                                    "span",
                                    { attrs: { slot: "label" }, slot: "label" },
                                    [
                                      _vm._v(
                                        "\n                Rövid leírás " +
                                          _vm._s(_vm.getLanguageName(locale)) +
                                          " nyelven\n              "
                                      )
                                    ]
                                  ),
                                  _c("Wysiwyg", {
                                    directives: [
                                      {
                                        name: "decorator",
                                        rawName: "v-decorator",
                                        value: [
                                          _vm.getTranslatedFieldName(
                                            "shortDescription",
                                            locale
                                          ),
                                          {
                                            initialValue: value,
                                            rules: [
                                              {
                                                required: !_vm.isTranslationEditDisabled,
                                                preserve: true,
                                                message: "Kérjük töltse ki!"
                                              },
                                              {
                                                transform: function(value) {
                                                  return _vm.stripTags(value)
                                                },
                                                min: !_vm.isTranslationEditDisabled
                                                  ? _vm.characterCounts[
                                                      _vm.getTranslatedFieldName(
                                                        "shortDescription",
                                                        locale
                                                      )
                                                    ].min
                                                  : undefined,
                                                max: !_vm.isTranslationEditDisabled
                                                  ? _vm.characterCounts[
                                                      _vm.getTranslatedFieldName(
                                                        "shortDescription",
                                                        locale
                                                      )
                                                    ].max
                                                  : undefined,
                                                message:
                                                  "Kérjük töltse ki! A leírás hosszának " +
                                                  _vm.characterCounts[
                                                    _vm.getTranslatedFieldName(
                                                      "shortDescription",
                                                      locale
                                                    )
                                                  ].min +
                                                  " és " +
                                                  _vm.characterCounts[
                                                    _vm.getTranslatedFieldName(
                                                      "shortDescription",
                                                      locale
                                                    )
                                                  ].max +
                                                  " között kell lennie."
                                              }
                                            ],
                                            validateTrigger: ["blur", "keyup"]
                                          }
                                        ],
                                        expression:
                                          "[\n                                  getTranslatedFieldName('shortDescription', locale),\n                                  {\n                                    initialValue: value,\n                                    rules: [\n                                        {\n                                          required: !isTranslationEditDisabled,\n                                          preserve: true,\n                                          message: 'Kérjük töltse ki!'\n                                        },\n                                        {\n                                          transform: (value) => {\n                                            return stripTags(value);\n                                          },\n                                          min: !isTranslationEditDisabled ? characterCounts[getTranslatedFieldName('shortDescription', locale)].min : undefined,\n                                          max: !isTranslationEditDisabled ? characterCounts[getTranslatedFieldName('shortDescription', locale)].max : undefined,\n                                          message: 'Kérjük töltse ki! A leírás hosszának ' + characterCounts[getTranslatedFieldName('shortDescription', locale)].min\n                                          + ' és ' + characterCounts[getTranslatedFieldName('shortDescription', locale)].max + ' között kell lennie.',\n                                        }\n                                    ],\n                                    validateTrigger: ['blur', 'keyup']\n                                }\n                              ]"
                                      }
                                    ],
                                    ref: _vm.getTranslatedFieldName(
                                      "shortDescription",
                                      locale
                                    ),
                                    refInFor: true,
                                    attrs: {
                                      maxLength: 25000,
                                      height: 100,
                                      disabled: false,
                                      readOnly: _vm.isTranslationEditDisabled,
                                      autoSize: { minRows: 2 }
                                    },
                                    on: {
                                      keyup: _vm.characterCount,
                                      change: _vm.characterCount,
                                      blur: function($event) {
                                        return _vm.updateTranslatedFormField(
                                          "shortDescription"
                                        )
                                      }
                                    }
                                  }),
                                  _c(
                                    "div",
                                    { staticClass: "character-count" },
                                    [
                                      _c(
                                        "strong",
                                        {
                                          class: {
                                            invalid:
                                              _vm.characterCounts[
                                                _vm.getTranslatedFieldName(
                                                  "shortDescription",
                                                  locale
                                                )
                                              ].valid === false,
                                            valid:
                                              _vm.characterCounts[
                                                _vm.getTranslatedFieldName(
                                                  "shortDescription",
                                                  locale
                                                )
                                              ].valid === true
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.characterCounts[
                                                  _vm.getTranslatedFieldName(
                                                    "shortDescription",
                                                    locale
                                                  )
                                                ].current
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      ),
                                      _vm._v(
                                        "\n\n                / " +
                                          _vm._s(
                                            _vm.characterCounts[
                                              _vm.getTranslatedFieldName(
                                                "shortDescription",
                                                locale
                                              )
                                            ].min
                                          ) +
                                          " -\n                " +
                                          _vm._s(
                                            _vm.characterCounts[
                                              _vm.getTranslatedFieldName(
                                                "shortDescription",
                                                locale
                                              )
                                            ].max
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ])
                      : _vm._e()
                  ],
                  1
                )
              }),
              _c(
                "a-form-item",
                [
                  _c(
                    "a-button",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        type: "dashed",
                        disabled:
                          _vm.isOfficeEmployee ||
                          !_vm.getFirstAvailableLanguage("shortDescription")
                      },
                      on: {
                        click: function($event) {
                          return _vm.addTranslatedFormField("shortDescription")
                        }
                      }
                    },
                    [
                      _c("a-icon", { attrs: { type: "plus" } }),
                      _vm._v(
                        "\n\n          Idegennyelvű rövid leírás hozzáadása\n        "
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "a-form-item",
                {
                  attrs: {
                    selfUpdate: true,
                    label: "Közepes leírás (200-1000 karakter)"
                  }
                },
                [
                  _c("Wysiwyg", {
                    directives: [
                      {
                        name: "decorator",
                        rawName: "v-decorator",
                        value: [
                          "mediumDescription",
                          {
                            rules: [
                              {
                                transform: function(value) {
                                  return _vm.stripTags(value)
                                },
                                required: _vm.mediumDescriptionRequired,
                                preserve: true,
                                min: _vm.characterCounts.mediumDescription.min,
                                max: _vm.characterCounts.mediumDescription.max,
                                message:
                                  "Kérjük töltse ki! A leírás hosszának " +
                                  _vm.characterCounts.mediumDescription.min +
                                  " és " +
                                  _vm.characterCounts.mediumDescription.max +
                                  " között kell lennie."
                              }
                            ],
                            validateTrigger: ["blur", "keyup"]
                          }
                        ],
                        expression:
                          "[\n                          'mediumDescription',\n                          {\n                              rules: [\n                                  {\n                                    transform: (value) => {\n                                      return stripTags(value);\n                                    },\n                                    required: mediumDescriptionRequired,\n                                    preserve: true,\n                                    min: characterCounts.mediumDescription.min,\n                                    max: characterCounts.mediumDescription.max,\n                                    message: 'Kérjük töltse ki! A leírás hosszának ' + characterCounts.mediumDescription.min\n                                    + ' és ' + characterCounts.mediumDescription.max + ' között kell lennie.',\n                                  }\n                              ],\n                              validateTrigger: ['blur', 'keyup']\n                          }\n                      ]"
                      }
                    ],
                    attrs: {
                      maxLength: 25000,
                      height: 250,
                      autoSize: {
                        minRows: 3
                      }
                    },
                    on: {
                      keyup: _vm.characterCount,
                      change: _vm.characterCount
                    }
                  }),
                  _c("div", { staticClass: "character-count" }, [
                    _c(
                      "strong",
                      {
                        class: {
                          invalid:
                            _vm.characterCounts.mediumDescription.valid ===
                            false,
                          valid:
                            _vm.characterCounts.mediumDescription.valid === true
                        }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.characterCounts.mediumDescription.current
                            ) +
                            "\n          "
                        )
                      ]
                    ),
                    _vm._v(
                      "\n\n          / " +
                        _vm._s(_vm.characterCounts.mediumDescription.min) +
                        " - " +
                        _vm._s(_vm.characterCounts.mediumDescription.max) +
                        "\n        "
                    )
                  ])
                ],
                1
              ),
              _vm._l(_vm.translatedFormFields["mediumDescription"], function(
                value,
                locale
              ) {
                return _c(
                  "div",
                  { key: "mediumDescription-" + locale },
                  [
                    value !== null
                      ? _c("a-row", [
                          _c(
                            "div",
                            [
                              _c(
                                "a-form-item",
                                [
                                  _c(
                                    "div",
                                    { attrs: { slot: "label" }, slot: "label" },
                                    [
                                      _vm._v(
                                        "\n                Nyelv\n              "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "a-select",
                                    {
                                      directives: [
                                        {
                                          name: "decorator",
                                          rawName: "v-decorator",
                                          value: [
                                            _vm.getTranslatedLocaleName(
                                              "mediumDescription",
                                              locale
                                            ),
                                            {
                                              initialValue: locale,
                                              rules: [
                                                {
                                                  required: false
                                                }
                                              ]
                                            }
                                          ],
                                          expression:
                                            "[\n                              getTranslatedLocaleName('mediumDescription', locale),\n                              {\n                                  initialValue: locale,\n                                  rules: [{\n                                      required: false,\n                                  }]\n                              }\n                          ]"
                                        }
                                      ],
                                      ref: _vm.getTranslatedLocaleName(
                                        "mediumDescription",
                                        locale
                                      ),
                                      refInFor: true,
                                      staticStyle: { width: "90%" },
                                      attrs: {
                                        getPopupContainer: _vm.getParentTriggerNode(),
                                        disabled: _vm.isTranslationEditDisabled
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.updateTranslatedFormField(
                                            "mediumDescription"
                                          )
                                        }
                                      }
                                    },
                                    _vm._l(_vm.languages, function(language) {
                                      return _c(
                                        "a-select-option",
                                        {
                                          key: language.locale,
                                          attrs: {
                                            value: language.locale,
                                            disabled: !_vm.isLanguageAvailable(
                                              "mediumDescription",
                                              language.locale
                                            )
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                language.name.toLowerCase()
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    }),
                                    1
                                  ),
                                  _vm.isAdmin
                                    ? _c(
                                        "a-tooltip",
                                        { attrs: { title: "Mező törlése" } },
                                        [
                                          _c("a-icon", {
                                            staticClass:
                                              "dynamic-delete-button",
                                            attrs: {
                                              type: "delete",
                                              theme: "filled"
                                            },
                                            on: {
                                              click: function() {
                                                return _vm.deleteTranslatedFormField(
                                                  "mediumDescription",
                                                  locale
                                                )
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            [
                              _c(
                                "a-form-item",
                                { attrs: { selfUpdate: true } },
                                [
                                  _c(
                                    "span",
                                    { attrs: { slot: "label" }, slot: "label" },
                                    [
                                      _vm._v(
                                        "\n                Közepes leírás " +
                                          _vm._s(_vm.getLanguageName(locale)) +
                                          " nyelven\n              "
                                      )
                                    ]
                                  ),
                                  _c("Wysiwyg", {
                                    directives: [
                                      {
                                        name: "decorator",
                                        rawName: "v-decorator",
                                        value: [
                                          _vm.getTranslatedFieldName(
                                            "mediumDescription",
                                            locale
                                          ),
                                          {
                                            initialValue: value,
                                            rules: [
                                              {
                                                required: _vm.isTranslationEditDisabled
                                                  ? false
                                                  : _vm.mediumDescriptionRequired,
                                                preserve: true,
                                                message: "Kérjük töltse ki!"
                                              },
                                              {
                                                transform: function(value) {
                                                  return _vm.stripTags(value)
                                                },
                                                min: !_vm.isTranslationEditDisabled
                                                  ? _vm.characterCounts[
                                                      _vm.getTranslatedFieldName(
                                                        "mediumDescription",
                                                        locale
                                                      )
                                                    ].min
                                                  : undefined,
                                                max: !_vm.isTranslationEditDisabled
                                                  ? _vm.characterCounts[
                                                      _vm.getTranslatedFieldName(
                                                        "mediumDescription",
                                                        locale
                                                      )
                                                    ].max
                                                  : undefined,
                                                message:
                                                  "Kérjük töltse ki! A leírás hosszának " +
                                                  _vm.characterCounts[
                                                    _vm.getTranslatedFieldName(
                                                      "mediumDescription",
                                                      locale
                                                    )
                                                  ].min +
                                                  " és " +
                                                  _vm.characterCounts[
                                                    _vm.getTranslatedFieldName(
                                                      "mediumDescription",
                                                      locale
                                                    )
                                                  ].max +
                                                  " között kell lennie."
                                              }
                                            ],
                                            validateTrigger: ["blur", "keyup"]
                                          }
                                        ],
                                        expression:
                                          "[\n                                  getTranslatedFieldName('mediumDescription', locale),\n                                  {\n                                    initialValue: value,\n                                    rules: [\n                                        {\n                                          required: isTranslationEditDisabled ? false : mediumDescriptionRequired,\n                                          preserve: true,\n                                          message: 'Kérjük töltse ki!'\n                                        },\n                                        {\n                                          transform: (value) => {\n                                            return stripTags(value);\n                                          },\n                                          min: !isTranslationEditDisabled ? characterCounts[getTranslatedFieldName('mediumDescription', locale)].min : undefined,\n                                          max: !isTranslationEditDisabled ? characterCounts[getTranslatedFieldName('mediumDescription', locale)].max : undefined,\n                                          message: 'Kérjük töltse ki! A leírás hosszának ' + characterCounts[getTranslatedFieldName('mediumDescription', locale)].min\n                                          + ' és ' + characterCounts[getTranslatedFieldName('mediumDescription', locale)].max + ' között kell lennie.',\n                                        }\n                                    ],\n                                    validateTrigger: ['blur', 'keyup']\n                                }\n                              ]"
                                      }
                                    ],
                                    ref: _vm.getTranslatedFieldName(
                                      "mediumDescription",
                                      locale
                                    ),
                                    refInFor: true,
                                    attrs: {
                                      maxLength: 25000,
                                      height: 250,
                                      disabled: false,
                                      readOnly: _vm.isTranslationEditDisabled,
                                      autoSize: { minRows: 2 }
                                    },
                                    on: {
                                      keyup: _vm.characterCount,
                                      change: _vm.characterCount,
                                      blur: function($event) {
                                        return _vm.updateTranslatedFormField(
                                          "mediumDescription"
                                        )
                                      }
                                    }
                                  }),
                                  _c(
                                    "div",
                                    { staticClass: "character-count" },
                                    [
                                      _c(
                                        "strong",
                                        {
                                          class: {
                                            invalid:
                                              _vm.characterCounts[
                                                _vm.getTranslatedFieldName(
                                                  "mediumDescription",
                                                  locale
                                                )
                                              ].valid === false,
                                            valid:
                                              _vm.characterCounts[
                                                _vm.getTranslatedFieldName(
                                                  "mediumDescription",
                                                  locale
                                                )
                                              ].valid === true
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.characterCounts[
                                                  _vm.getTranslatedFieldName(
                                                    "mediumDescription",
                                                    locale
                                                  )
                                                ].current
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      ),
                                      _vm._v(
                                        "\n\n                / " +
                                          _vm._s(
                                            _vm.characterCounts[
                                              _vm.getTranslatedFieldName(
                                                "mediumDescription",
                                                locale
                                              )
                                            ].min
                                          ) +
                                          " -\n                " +
                                          _vm._s(
                                            _vm.characterCounts[
                                              _vm.getTranslatedFieldName(
                                                "mediumDescription",
                                                locale
                                              )
                                            ].max
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ])
                      : _vm._e()
                  ],
                  1
                )
              }),
              _c(
                "a-form-item",
                [
                  _c(
                    "a-button",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        type: "dashed",
                        disabled:
                          _vm.isOfficeEmployee ||
                          !_vm.getFirstAvailableLanguage("mediumDescription")
                      },
                      on: {
                        click: function($event) {
                          return _vm.addTranslatedFormField("mediumDescription")
                        }
                      }
                    },
                    [
                      _c("a-icon", { attrs: { type: "plus" } }),
                      _vm._v(
                        "\n\n          Idegennyelvű közepes leírás hozzáadása\n        "
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "a-form-item",
                [
                  _vm.showSaveButton
                    ? _c(
                        "a-button",
                        {
                          attrs: {
                            type: "primary",
                            "html-type": "submit",
                            loading: _vm.submitLoading
                          }
                        },
                        [_vm._v("\n          Mentés\n        ")]
                      )
                    : _vm._e(),
                  _vm.hasChanged()
                    ? _c(
                        "a-button",
                        {
                          attrs: { type: "secondary", "html-type": "button" },
                          on: { click: _vm.resetForm }
                        },
                        [
                          _c("a-icon", {
                            attrs: { type: "undo", theme: "outlined" }
                          }),
                          _vm._v("\n\n          Piszkozat törlése\n        ")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.currentTab
                    ? _c("span", { staticClass: "last-modification" }, [
                        _vm._v("\n          Utolsó mentés: "),
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm
                                .moment(_vm.currentTab.modificationTime)
                                .format(_vm.timeStampFormat)
                                .toString()
                            )
                          )
                        ]),
                        _vm._v("  "),
                        _vm.currentTab.user
                          ? _c("span", [
                              _vm._v(
                                "(" + _vm._s(_vm.currentTab.user.userName) + ")"
                              )
                            ])
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm.submitResult.show
                    ? _c("a-alert", {
                        style: {
                          marginTop: "10px"
                        },
                        attrs: {
                          message: _vm.submitResult.message,
                          type: _vm.submitResult.type,
                          showIcon: "",
                          closable: "",
                          afterClose: function() {
                            return (_vm.submitResult.show = false)
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }